import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsAndConditions: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Hero Section */}
      <section style={{
        background: '#1C46BE',
        color: 'white',
        padding: '120px 0 60px',
        position: 'relative',
        height: '550px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          textAlign: 'center'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14,2 14,8 20,8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10,9 9,9 8,9"/>
              </svg>
            </div>
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: '700',
              margin: '0',
              lineHeight: '1.1'
            }}>
              Terms & Conditions
            </h1>
            <p style={{
              fontSize: '1.3rem',
              opacity: '0.9',
              maxWidth: '600px',
              margin: '0',
              lineHeight: '1.6'
            }}>
              Please read these terms and conditions carefully before using our services
            </p>
          </div>
        </div>

        {/* Wave */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          overflow: 'hidden',
          lineHeight: '0'
        }}>
          <svg style={{
            position: 'relative',
            display: 'block',
            width: 'calc(100% + 1.3px)',
            height: '60px'
          }} viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,60 C400,120 600,10 800,20 C1000,20 1100,35 1200,60 L1200,120 L0,120 Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Main Content */}
      <main style={{
        flex: '1',
        padding: '80px 0',
        background: '#ffffff'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '0 20px'
        }}>
          <div style={{
            background: '#ffffff',
            borderRadius: '12px',
            padding: '60px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e5e7eb'
          }}>

            {/* Last Updated */}
            <div style={{
              background: '#f8fafc',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '40px',
              borderLeft: '4px solid #1C46BE'
            }}>
              <p style={{
                margin: '0',
                color: '#64748b',
                fontSize: '14px'
              }}>
                <strong>Last Updated:</strong> September 30, 2025
              </p>
            </div>

            {/* Introduction */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                1. Introduction
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                Welcome to Sort My Business With AI ("we," "our," or "us"). These Terms and Conditions ("Terms") govern your use of our AI-powered business management platform and services provided through our website and applications.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.
              </p>
            </section>

            {/* Acceptance of Terms */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                2. Acceptance of Terms
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                You must be at least 18 years old to use our services. By using our platform, you represent and warrant that you are at least 18 years of age and have the legal capacity to enter into these Terms.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                We reserve the right to modify these Terms at any time. We will notify users of any material changes via email or through our platform.
              </p>
            </section>

            {/* Services Description */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                3. Services Description
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                Sort My Business With AI provides AI-powered business management solutions including but not limited to:
              </p>
              <ul style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 20px'
              }}>
                <li>Customer relationship management</li>
                <li>Inventory and purchasing management</li>
                <li>Financial reporting and analytics</li>
                <li>E-commerce integration</li>
                <li>Business process optimization</li>
                <li>AI-powered insights and recommendations</li>
              </ul>
            </section>

            {/* Free Trial and Subscription */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                4. Free Trial and Subscription Terms
              </h2>
              <div style={{
                background: '#f0f9ff',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #0ea5e9'
              }}>
                <h3 style={{
                  color: '#0c4a6e',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  margin: '0 0 10px 0'
                }}>
                  30-Day Free Trial
                </h3>
                <p style={{
                  color: '#0c4a6e',
                  margin: '0',
                  lineHeight: '1.6'
                }}>
                  We offer a 30-day free trial for all new users. No credit card is required to start your trial. The trial includes access to all features and functionalities of your selected system.
                </p>
              </div>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                <strong>Subscription Plans:</strong> After your free trial ends, you will be charged according to the monthly subscription plan for your selected system. Different systems have different pricing structures, which will be clearly communicated to you during the setup process.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                <strong>Billing:</strong> Subscriptions are billed monthly in advance unless otherwise specified. All fees are non-refundable except as required by applicable law or as stated in our refund policy.
              </p>
            </section>

            {/* Cancellation */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                5. Cancellation Policy
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                You may cancel your subscription at any time through your account settings or by contacting our support team. Cancellation will take effect at the end of your current billing period.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                Upon cancellation, you will continue to have access to the services until the end of your paid billing period. After that, your access will be terminated, though we may retain your data as outlined in our Privacy Policy.
              </p>
            </section>

            {/* Refund Policy */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                6. Refund Policy
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                Our refund policy complies with GDPR requirements and applicable Irish and EU consumer protection laws. Refunds may be provided in cases of service failure, technical issues that prevent normal use, or as required by law. Refund requests must be submitted within 14 days of the issue occurring.
              </p>
            </section>

            {/* Data Ownership */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                7. Data Ownership and Database Options
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                <strong>Your Data:</strong> You retain ownership of all business data you input into our system. However, we maintain control and administrative access to ensure service quality and security.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                <strong>Dedicated Database Option:</strong> For users willing to pay additional fees, we offer dedicated database instances. This option provides enhanced data isolation while maintaining our administrative oversight for support and security purposes.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                <strong>Data Export:</strong> Upon request and with proper authentication, we can provide you with a copy of your data in a standard format, subject to our data export procedures and any applicable fees.
              </p>
            </section>

            {/* AI Limitations */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                8. AI Limitations and Disclaimers
              </h2>
              <div style={{
                background: '#fef3c7',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #f59e0b'
              }}>
                <h3 style={{
                  color: '#92400e',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  margin: '0 0 10px 0'
                }}>
                  Important AI Disclaimer
                </h3>
                <p style={{
                  color: '#92400e',
                  margin: '0',
                  lineHeight: '1.6'
                }}>
                  Our AI provides suggestions and recommendations based on data analysis. These are not facts and should not be considered as professional business, financial, or legal advice.
                </p>
              </div>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                <strong>No Guarantee of Accuracy:</strong> AI-generated insights, predictions, and recommendations are based on algorithms and data patterns. They may be incorrect, incomplete, or not suitable for your specific business situation.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                <strong>Your Responsibility:</strong> You are solely responsible for all business decisions made using our platform. We strongly recommend consulting with qualified professionals before making significant business decisions based on AI recommendations.
              </p>
            </section>

            {/* Intellectual Property */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                9. Intellectual Property Rights
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                Sort My Business With AI owns all intellectual property rights in the platform, including but not limited to:
              </p>
              <ul style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 20px'
              }}>
                <li>AI models and algorithms</li>
                <li>Software code and architecture</li>
                <li>System designs and user interfaces</li>
                <li>Generated reports and analytics formats</li>
                <li>All proprietary methodologies and processes</li>
              </ul>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                You may not copy, modify, distribute, or reverse engineer any part of our platform without explicit written permission.
              </p>
            </section>

            {/* Service Availability */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                10. Service Availability
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                Our services are hosted on Amazon Web Services (AWS), which provides a 99.9% uptime guarantee. While we strive to maintain continuous service availability, we cannot guarantee uninterrupted access due to factors beyond our control.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                We will provide reasonable notice for planned maintenance and work to minimize service disruptions.
              </p>
            </section>

            {/* Account Termination */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                11. Account Termination
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                <strong>User Termination:</strong> You may terminate your account at any time, provided all outstanding bills have been paid.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                <strong>Our Right to Terminate:</strong> We reserve the right to suspend or terminate accounts for violations of these Terms, non-payment, illegal activity, or misuse of our services.
              </p>
            </section>

            {/* Limitation of Liability */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                12. Limitation of Liability
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                To the maximum extent permitted by Irish and EU law, Sort My Business With AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                Our total liability to you for any claims arising from these Terms or your use of our services shall not exceed the amount you paid us in the 12 months preceding the claim.
              </p>
            </section>

            {/* Governing Law */}
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                13. Governing Law and Dispute Resolution
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                These Terms are governed by the laws of Ireland. Any disputes arising from these Terms or your use of our services will be subject to the exclusive jurisdiction of the Irish courts.
              </p>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0'
              }}>
                We encourage users to contact us directly to resolve any issues before pursuing formal legal action.
              </p>
            </section>

            {/* Contact Information */}
            <section style={{ marginBottom: '0' }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb'
              }}>
                14. Contact Information
              </h2>
              <p style={{
                color: '#475569',
                lineHeight: '1.7',
                margin: '0 0 15px 0'
              }}>
                If you have any questions about these Terms and Conditions, please contact us:
              </p>
              <div style={{
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <p style={{
                  margin: '0 0 10px 0',
                  color: '#374151'
                }}>
                  <strong>Email:</strong> info@sortmybusinesswithai.ie
                </p>
                <p style={{
                  margin: '0 0 10px 0',
                  color: '#374151'
                }}>
                  <strong>Phone:</strong> +353 87 2526280
                </p>
                <p style={{
                  margin: '0',
                  color: '#374151'
                }}>
                  <strong>Business Name:</strong> Sort My Business With AI
                </p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;